import { useMutation } from '@tanstack/react-query'
import { aiApi } from '@/api/ai'

/**
 * Real tool-calling agents (ai-engine/app/agents/{shopping,analytics,support}_agent.py) —
 * same correct working pattern as useAiUsage.ts (shared-core's aiApi + bearer-token http
 * client through the gateway), not lib/ops.ts's pre-existing broken `/agent` proxy (see
 * AI_OPS_INTEGRATION.md — that path was built against a different, never-real "ai-ops agent"
 * sibling service with its own LangGraph orchestrator/IoT simulator/MQTT feed, none of which
 * exist in this repo).
 */

export function useAgentChat() {
  return useMutation({
    mutationFn: ({ message, sessionId }: { message: string; sessionId?: string }) =>
      aiApi.agentChat(message, sessionId),
  })
}

export function useAnalyticsAgentChat() {
  return useMutation({
    mutationFn: ({ message, sessionId }: { message: string; sessionId?: string }) =>
      aiApi.analyticsAgentChat(message, sessionId),
  })
}

export function useSupportAgentChat() {
  return useMutation({
    mutationFn: ({ message, sessionId }: { message: string; sessionId?: string }) =>
      aiApi.supportAgentChat(message, sessionId),
  })
}
